import { EnergySourcingContractsTableContainer } from '../EnergySourcingContractsTableContainer/EnergySourcingContractsTableContainer'

export const EnergySourcingContracts = () => {
    return (
        <div className="h-full overflow-hidden p-6">
            <EnergySourcingContractsTableContainer />
        </div>
    )
}
